export default __webpack_public_path__ + "static/media/image02.d7806a6c.jpg";